import axiosInstance from "../axiosinstance";

export async function getProcessActivityReport(projectId, query, signal) {
  const response = await axiosInstance.get(
    `/api/v2/processes/report/${encodeURIComponent(projectId)}`,
    {
      params: {
        page: query.page,
        page_size: query.pageSize,
        status: query.status,
        sort_by: query.sortBy,
        sort_direction: query.sortDirection,
        date_basis: query.dateBasis,
        ...(query.dateFrom ? { date_from: query.dateFrom } : {}),
        ...(query.dateTo ? { date_to: query.dateTo } : {}),
        ...(query.performedBy ? { performed_by: query.performedBy } : {}),
        ...(query.search ? { search: query.search } : {}),
      },
      signal,
    },
  );
  return response.data;
}

export async function exportProcessActivityReport(projectId, query) {
  return axiosInstance.get(
    `/api/v2/processes/report/${encodeURIComponent(projectId)}`,
    {
      params: {
        page: 1,
        page_size: 100,
        status: query.status,
        sort_by: query.sortBy,
        sort_direction: query.sortDirection,
        date_basis: query.dateBasis,
        format: "xlsx",
        ...(query.dateFrom ? { date_from: query.dateFrom } : {}),
        ...(query.dateTo ? { date_to: query.dateTo } : {}),
        ...(query.performedBy ? { performed_by: query.performedBy } : {}),
        ...(query.search ? { search: query.search } : {}),
      },
      responseType: "blob",
    },
  );
}

